import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import {
  RentalGroupSuccessDialogComponent,
  RentalGroupSuccessDialogData,
} from './rental-group-success-dialog.component'

@Injectable()
export class RentalGroupSuccessDialogService {
  constructor(private dialog: MatDialog) {}

  public open(data: RentalGroupSuccessDialogData) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { ...data },
    }

    return this.dialog.open(RentalGroupSuccessDialogComponent, defaultConfig)
  }
}
